import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Col, Container, Image, Row } from 'react-bootstrap'
import { faCircleUser, faHome, faIcons, faMagnifyingGlass, } from '@fortawesome/free-solid-svg-icons';
import { Link, useLocation, useParams } from 'react-router-dom';
import './bottomnav.css'
export default function BottomNavigation() {
    const location = useLocation();
    const pathname = location.pathname
    const segment = pathname.split('/')
    // const user_id = localStorage.getItem('dastaan__user_id') !== undefined ? localStorage.getItem('dastaan__user_id') : 0
  
    return (
        //
        <Container>
            <Row className='bottom-menu'>
                <Col md={4} xs={3} lg={4} className='text-center'>
                    <Link to='/'>
                        <FontAwesomeIcon className={`${pathname == '/' ? 'menu-active-color' : 'text-white'} bottom-icon`} icon={faHome} />
                        <br />
                        <small className='menu-items text-white'>Home</small>
                    </Link>
                </Col>
                   <Col md={4} xs={3} lg={4} className='text-center'>
                    <Link to='/categories'>
                        <FontAwesomeIcon className={`${(segment[1] == 'categories' || segment[1] == 'category-details' ) ? 'menu-active-color' : 'text-white'} bottom-icon`} icon={faIcons} />
                        <br />
                        <small className='menu-items text-white'>Categories</small>
                    </Link>
                </Col>
                <Col md={4} xs={3} lg={4} className='text-center'>
                    <Link to='/search'>
                        <FontAwesomeIcon className={`${pathname == '/search' ? 'menu-active-color' : 'text-white'} bottom-icon`} icon={faMagnifyingGlass} />
                        <br />
                        <small className='menu-items text-white'>Search</small>
                    </Link>
                </Col>



             
                {/*   <Col md={4} xs={2} lg={4} className='text-center' >
                    <Link to='/categories'>
                        <FontAwesomeIcon  className={pathname == '/categories' ? 'menu-active-color' : 'text-white'} icon={faCircleUser} />
                        <br />
                        <small className='menu-items text-white'>Categorie  s</small>
                    </Link>
                </Col>  */}
               
                        <Col md={3} xs={3} lg={4} className='text-center'>
                            <Link to='/my-space'>
                                <FontAwesomeIcon
                                    className={`${(
                                        pathname == '/my-space'
                                        || pathname == '/dashboard'
                                        || pathname == '/download-invoice'
                                        || pathname == '/pages/About%20Us'
                                        || pathname == '/pages/Privacy%20Policy'
                                        || pathname == '/pages/Refund%20Policy'
                                        || pathname == '/pages/Terms%20and%20Condition'
                                        || pathname == '/Psearchdashboard'
                                        || pathname == '/pages/Grievance%20Policy'
                                    ) ? 'menu-active-color' : 'text-white'} bottom-icon`} icon={faCircleUser} />
                                <br />
                                <small className='menu-items text-white'>Profile</small>
                            </Link>
                        </Col>
                
            </Row>
        </Container>
    )
}
